<template>
  <div
    id="infinity-updater"
    v-scroll="handleScroll">
    <sButton
      v-if="max_scroll_count != 'none' && scroll_count == max_scroll_count && active"
      class="h11-links my-3"
      @click="loadMore">
      {{ $t('Common.DownloadMore') }}
    </sButton>
    <sIcon
      v-else-if="load || loading"
      color="var(--white-color)"
      size="30"
      spin
      type="loading"/>
  </div>
</template>

<script>

export default {
  name: 'infinityUpdater',
  data() {
    return {
      load: false,
      element: null,
      scroll_count: -1,
    }
  },
  props: {
    active: Boolean,
    callOnMount: Boolean,
    loading: Boolean,
    listener: [Object, String, Number, Boolean, Array],
    pixels_when_update: {
      type: [String, Number],
      default: () => 60
    },
    selector: {
      type: [String],
      default: () => '#components'
    },
    /*
      значення none - без кнопки взагалі
    */
    max_scroll_count: {
      type: [String, Number],
      default: () => 'none'
    },
    action: {
      type: Function,
      default: () => {}
    }
  },
  created() {
  },
  mounted() {
    this.$root.$emit('enableUpBtn', this.selector )
    this.element = document.querySelector(this.selector)

    this.scrollSubs()

    if (this.callOnMount) {
      this.handleScroll(true)
    } else {
      this.updateScrollCount()
    }
  },
  beforeDestroy() {
    this.scrollUnSubs()
  },
  methods: {
    scrollSubs() {
      if (this.element ) {
        this.element.addEventListener('scroll', this.handleScroll, false)
      }
    },
    scrollUnSubs() {
      if (this.element ) {
        this.element.removeEventListener('scroll', this.handleScroll, false)
      }
    },
    isVisible() {
      let el = document.getElementById('infinity-updater')

      if (this.element) {
        return this.element.scrollHeight <= this.element.scrollTop + this.element.clientHeight + (+this.pixels_when_update)
      }
      return window.scrollY + window.innerHeight
        > el?.offsetParent?.offsetTop + el?.clientHeight + this.pixels_when_update
    },
    async handleScroll(initiate) {
      let visible = this.isVisible(),
        condation = (this.max_scroll_count == 'none' || this.scroll_count < this.max_scroll_count )
        && this.active && !this.load && visible

      if (condation || typeof initiate == 'boolean') {
        await this.callAction()
        this.updateScrollCount()
        return true
      }
      return false
    },
    async callAction() {
      this.load = true
      if (this.action) {
        await this.action()
      } else {
        this.$emit('action')
      }

      this.load = false
    },
    updateScrollCount(zeroing) {
      if ( this.max_scroll_count != 'none' ) {
        this.scroll_count = zeroing ? 0 : this.scroll_count + 1
      }
    },
    async loadMore() {
      await this.callAction()
      this.updateScrollCount(true)
    }
  },
  watch: {
  }
}
</script>
